export const Calculate = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="8.5" y="4.5" width="1" height="9" stroke="currentColor"/>
<rect x="13.5" y="8.5" width="1" height="9" transform="rotate(90 13.5 8.5)" stroke="currentColor"/>
<rect x="27.5" y="8.5" width="1" height="9" transform="rotate(90 27.5 8.5)" stroke="currentColor"/>
<rect x="27.4999" y="19.5" width="1" height="9" transform="rotate(90 27.4999 19.5)" stroke="currentColor"/>
<rect x="27.4999" y="24.5" width="1" height="9" transform="rotate(90 27.4999 24.5)" stroke="currentColor"/>
<rect x="12.5814" y="17.715" width="1.00612" height="11.1359" transform="rotate(45 12.5814 17.715)" stroke="currentColor"/>
<rect x="13.2928" y="25.5891" width="1.00612" height="11.1359" transform="rotate(135 13.2928 25.5891)" stroke="currentColor"/>
</svg>`;
